import { type RefObject, useEffect, useRef, useState } from 'react';

// A clock for labels like "12s ago": ticks while the page is open, so rendering stays pure.
export function useNow(every: number): number {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), every);

        return () => clearInterval(timer);
    }, [every]);

    return now;
}

// The width of an element, as it changes: a list compacts itself when it gets narrow.
export function useWidth<T extends HTMLElement>(): [RefObject<T | null>, number] {
    const ref = useRef<T>(null);
    const [width, setWidth] = useState(0);
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const observer = new ResizeObserver(([entry]) => setWidth(Math.floor(entry?.contentRect.width ?? 0)));
        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return [ref, width];
}
